/* @flow */

import React from 'react'
import cx from 'classnames'
import ARIA from '../constants/aria'
import NavContainer from '../containers/NavContainer'
import Disclaimer from '../components/Disclaimer'

import Link from 'gatsby-link'

const linkCx: string = 'sub-menu-item no-underline'

const hamStyl: Object = Object.freeze({
  borderRadius: '5px',
  height: '3px',
  marginTop: '-1px',
  transformOrigin: 'center center 0',
  transition: '0.3s ease',
})

type tPROPS = {
  showMobileNav: boolean;
  showModal: boolean;
  toggleMobileNav: Function;
  closeMobileNav: Function;
  toggleDropdownContent: Function;
  hideDropdownContent: Function;
  showDropdownContent: Function;
  handleOpenModal: Function;
  handleCloseModal: Function;
  activeDropdown: string;
  path: string;
  style: object;
  validated: boolean;
};

const Nav = (props: tPROPS) => {
  const {
    showMobileNav,
    showModal,
    toggleMobileNav,
    closeMobileNav,
    toggleDropdownContent,
    hideDropdownContent,
    showDropdownContent,
    handleOpenModal,
    handleCloseModal,
    activeDropdown,
    path,
    style,
    validated
  } = props

  const navCx = cx({
    'bg-white col d-5 flex-row': true,
    'tab-hide': !showMobileNav,
  })

  

  return (
    <nav className='bg-white clr-gray flex-box dir-column main-nav-bar' style={style}>
      {/* <Disclaimer validated={validated} handleCloseModal={handleCloseModal} showModal={showModal} /> */}
      <a
        href='#hero'
        className='visually-hidden'>
        Skip navigation, go to start of content
      </a>
      <div>
      <div className='container dir-column tab-pad-b-1 tab-pad-t-1 nav-bar'>
        <div className={showMobileNav ? 'dir-column relative': 'flex-row relative'}>
          <div className='container d-40 align-center logo-wrapper relative'>
            <Link
              className="nav-logos"
              to='/'>
              {/*<img
                alt='Go to FDA website'
                src='/img/FDA_logo_blue.png'
                className='fda-logo'
              />
              <div className="nav-bar-divider-line"/>*/}
              <img
                className='open-fda-logo'
                alt='Go to ftbcAcademy homepage'
                src='/img/ftbcAcademyLogoBlack.png'
              />
            </Link>
            <div
              className='absolute right d-hide'
              onClick={toggleMobileNav}
              style={{
                height: '25px',
                transform: 'rotate(0deg)',
                width: '36px',
              }}
            >
              <span
                className='absolute bg-primary block row'
                style={{
                  ...hamStyl,
                  transform: showMobileNav ?
                    'translate3d(0, 10px, 0) rotate(45deg)' :
                    'translate3d(0, 0, 0) rotate(0deg)',
                }}
              />
              <span
                className='absolute bg-primary block row'
                style={{
                  ...hamStyl,
                  transform: 'translate3d(0, 10px, 0)',
                  opacity: showMobileNav ? 0 : 1,
                }}
              />
              <span
                className='absolute bg-primary block row'
                style={{
                  ...hamStyl,
                  transform: showMobileNav ?
                    'translate3d(0, 10px, 0) rotate(-45deg)' :
                    'translate3d(0, 20px, 0) rotate(0deg)',
                }}
              />
            </div>
          </div>
          <div className={navCx}>
            <div className='menu-container responsive-header' role='navigation'>
              <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                <Link
                  title='Home'
                  to='/'
                  className={path === '/' ? 'menu-header header-selected emphasis': activeDropdown==='Home' ? 'menu-header emphasis': 'menu-header'}
                  onClick={closeMobileNav}
                >Home</Link>
                <div className={path === '/' ? 'menu-header-underbar': 'menu-header-underbar display-none'} style={{width: 'calc(100% - 1em)'}}/>
              </div>
              <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                <span
                  title='About'
                  className={path.indexOf('about') >= 0 ? 'menu-header header-selected emphasis': activeDropdown==='About' ? 'menu-header emphasis': 'menu-header'}
                  onTouchStart={toggleDropdownContent}
                >About <i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                <div className={path.indexOf('about') >= 0 ? 'menu-header-underbar': 'menu-header-underbar display-none'}/>
                <div className={activeDropdown==='About' ? 'dropdown-content display-block': 'dropdown-content display-none'}>
                  <div className='sub-menu-container' role='navigation'>
                    <Link className={linkCx} to='/about/introduction/' onClick={closeMobileNav}>What is ftbcAcademy</Link>
                    <Link className={linkCx} to='/about/topics_available/' onClick={closeMobileNav}>Available Topics</Link>
                    <Link className={linkCx} to='/about/topics_roadmap/' onClick={closeMobileNav}>Topics Roadmap</Link>
                    <Link className={linkCx} to='/about/how_to_use/' onClick={closeMobileNav}>How to Use</Link>
                    <Link className={linkCx} to='/about/contributors/' onClick={closeMobileNav}>Contributors</Link>
                    <Link className={linkCx} to='/about/pricing/' onClick={closeMobileNav}>Pricing</Link>
                    <Link className={linkCx} to='/about/updates/' onClick={closeMobileNav}>Updates</Link>
                  </div>
                </div>
              </div>
              <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                <span
                  title='FTBModules'
                  className={path.indexOf('ftbModules') >= 0 ? 'menu-header header-selected emphasis': activeDropdown==='FTBModules' ? 'menu-header emphasis': 'menu-header'}
                  onTouchStart={toggleDropdownContent}
                >FTB Modules<i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                <div className={path.indexOf('ftbModules') >= 0 ? 'menu-header-underbar': 'menu-header-underbar display-none'}/>
                <div className={activeDropdown==='FTBModules' ? 'dropdown-content display-block': 'dropdown-content display-none'}>
                  <div className='sub-menu-container' role='navigation'>
                    <Link className={linkCx} to='/ftbModules/' onClick={closeMobileNav}>Overview</Link>
                    <Link className={linkCx} to='/ftbModules/trade_lifecycle' onClick={closeMobileNav}>Trade Lifecycle</Link>
                    <Link className={linkCx} to='/ftbModules/new_entity' onClick={closeMobileNav}>New Entity Setup</Link>
                    {/* <Link className={linkCx} to='/ftbModules/cash_front_to_back/' onClick={closeMobileNav}>Cash Front to Back</Link>
                    <Link className={linkCx} to='/ftbModules/securities_front_to_back/' onClick={closeMobileNav}>Securities Front to Back</Link>
                    <Link className={linkCx} to='/ftbModules/exchange_front_to_back/' onClick={closeMobileNav}>Exchange Traded Instrument Front to Back</Link> */}
                  </div>
                </div>
              </div>
              <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                <span
                  title='Processes'
                  className={path.indexOf('processes') >= 0 ? 'menu-header header-selected emphasis': activeDropdown==='Processes' ? 'menu-header emphasis': 'menu-header'}
                  onTouchStart={toggleDropdownContent}
                >Processes<i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                <div className={path.indexOf('processes') >= 0 ? 'menu-header-underbar': 'menu-header-underbar display-none'}/>
                <div className={activeDropdown==='Processes' ? 'dropdown-content display-block': 'dropdown-content display-none'}>
                  <div className='sub-menu-container' role='navigation'>
                    <Link className={linkCx} to='/processes/' onClick={closeMobileNav}>Overview</Link>
                    <Link className={linkCx} to='/processes/frontoffice/' onClick={closeMobileNav}>Front Office</Link>
                    <Link className={linkCx} to='/processes/operations/' onClick={closeMobileNav}>Operations</Link>
                    <Link className={linkCx} to='/processes/finance/' onClick={closeMobileNav}>Finance</Link>
                    <Link className={linkCx} to='/processes/credit_risk/' onClick={closeMobileNav}>Credit Risk</Link>
                    <Link className={linkCx} to='/processes/market_risk/' onClick={closeMobileNav}>Market Risk</Link>
                    {/* <Link className={linkCx} to='/processes/compliance/' onClick={closeMobileNav}>Compliance</Link> */}
                  </div>
                </div>
              </div>
              <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                <span
                  title='Concepts'
                  className={path.indexOf('concepts') >= 0 ? 'menu-header header-selected emphasis': activeDropdown==='Concepts' ? 'menu-header emphasis': 'menu-header'}
                  onTouchStart={toggleDropdownContent}
                >Concepts<i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                <div className={path.indexOf('concepts') >= 0 ? 'menu-header-underbar': 'menu-header-underbar display-none'}/>
                <div className={activeDropdown==='Concepts' ? 'dropdown-content display-block': 'dropdown-content display-none'}>
                  <div className='sub-menu-container' role='navigation'>
                    <Link className={linkCx} to='/concepts/' onClick={closeMobileNav}>Overview</Link>
                    {/* <Link className={linkCx} to='/concepts/banking_concepts/' onClick={closeMobileNav}>Banking</Link>
                    <Link className={linkCx} to='/concepts/fundamentals_concepts/' onClick={closeMobileNav}>Fundamentals</Link> */}
                    <Link className={linkCx} to='/concepts/trade_lifecycle_concepts/' onClick={closeMobileNav}>Trade Lifecycle</Link>
                    <Link className={linkCx} to='/concepts/risk_management_concepts/' onClick={closeMobileNav}>Risk Management</Link>
                    <Link className={linkCx} to='/concepts/banking_concepts/bank_concepts/risk_origination' onClick={closeMobileNav}>Banking</Link>
                    {/* <Link className={linkCx} to='/concepts/reporting_concepts/' onClick={closeMobileNav}>Reporting</Link>
                    <Link className={linkCx} to='/concepts/control_concepts/' onClick={closeMobileNav}>Control</Link>
                    <Link className={linkCx} to='/concepts/operations_risk_concepts/' onClick={closeMobileNav}>Operations Risk</Link>
                    <Link className={linkCx} to='/concepts/compliance_concepts/' onClick={closeMobileNav}>Compliance</Link>
                    <Link className={linkCx} to='/concepts/regime_concepts/' onClick={closeMobileNav}>Regime</Link> */}
                  </div>
                </div>
              </div>
              {/* <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                <span
                  title='Products'
                  className={path.indexOf('products') >= 0 ? 'menu-header header-selected emphasis': activeDropdown==='Products' ? 'menu-header emphasis': 'menu-header'}
                  onTouchStart={toggleDropdownContent}
                >Products<i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                <div className={path.indexOf('products') >= 0 ? 'menu-header-underbar': 'menu-header-underbar display-none'}/>
                <div className={activeDropdown==='Products' ? 'dropdown-content display-block': 'dropdown-content display-none'}>
                  <div className='sub-menu-container' role='navigation'>
                    <Link className={linkCx} to='/products/' onClick={closeMobileNav}>Overview</Link>
                    <Link className={linkCx} to='/products/foreign_exchange/' onClick={closeMobileNav}>Foreign Exchange</Link>
                    <Link className={linkCx} to='/products/interest_rates/' onClick={closeMobileNav}>Interest Rates</Link>
                    <Link className={linkCx} to='/products/commodities/' onClick={closeMobileNav}>Commodities</Link>
                    <Link className={linkCx} to='/products/credit/' onClick={closeMobileNav}>Credit</Link>
                    <Link className={linkCx} to='/products/equities/' onClick={closeMobileNav}>Equities</Link>
                    <Link className={linkCx} to='/products/money_market/' onClick={closeMobileNav}>Money Market</Link>
                  </div>
                </div>
              </div> */}
              {/* <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                <span
                  title='People'
                  className={path.indexOf('people') >= 0 ? 'menu-header header-selected emphasis': activeDropdown==='People' ? 'menu-header emphasis': 'menu-header'}
                  onTouchStart={toggleDropdownContent}
                >People<i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                <div className={path.indexOf('people') >= 0 ? 'menu-header-underbar': 'menu-header-underbar display-none'}/>
                <div className={activeDropdown==='People' ? 'dropdown-content display-block': 'dropdown-content display-none'}>
                  <div className='sub-menu-container' role='navigation'>
                    <Link className={linkCx} to='/people/' onClick={closeMobileNav}>Overview</Link>
                    <Link className={linkCx} to='/people/front_office/' onClick={closeMobileNav}>Front Office</Link>
                    <Link className={linkCx} to='/people/operations/' onClick={closeMobileNav}>Operations</Link>
                    <Link className={linkCx} to='/people/finance/' onClick={closeMobileNav}>Finance</Link>
                    <Link className={linkCx} to='/people/credit_risk/' onClick={closeMobileNav}>Credit Risk</Link>
                    <Link className={linkCx} to='/people/market_risk/' onClick={closeMobileNav}>Market Risk</Link>
                    <Link className={linkCx} to='/people/compliance/' onClick={closeMobileNav}>Compliance</Link>
                    <Link className={linkCx} to='/people/technology/' onClick={closeMobileNav}>Technology</Link>
                  </div>
                </div>
              </div> */}
              {/* <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                <span
                  title='Data'
                  className={path.indexOf('data') >= 0 ? 'menu-header header-selected emphasis': activeDropdown==='Data' ? 'menu-header emphasis': 'menu-header'}
                  onTouchStart={toggleDropdownContent}
                >Data<i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                <div className={path.indexOf('data') >= 0 ? 'menu-header-underbar': 'menu-header-underbar display-none'}/>
                <div className={activeDropdown==='Data' ? 'dropdown-content display-block': 'dropdown-content display-none'}>
                  <div className='sub-menu-container' role='navigation'>
                    <Link className={linkCx} to='/data/' onClick={closeMobileNav}>Overview</Link>
                    <Link className={linkCx} to='/data/static_data/' onClick={closeMobileNav}>Static Data</Link>
                    <Link className={linkCx} to='/data/market_data/' onClick={closeMobileNav}>Market Data</Link>
                  </div>
                </div>
              </div> */}
              {/* <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                <span
                  title='Systems'
                  className={path.indexOf('systems') >= 0 ? 'menu-header header-selected emphasis': activeDropdown==='Systems' ? 'menu-header emphasis': 'menu-header'}
                  onTouchStart={toggleDropdownContent}
                >Systems<i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                <div className={path.indexOf('systems') >= 0 ? 'menu-header-underbar': 'menu-header-underbar display-none'}/>
                <div className={activeDropdown==='Systems' ? 'dropdown-content display-block': 'dropdown-content display-none'}>
                  <div className='sub-menu-container' role='navigation'>
                    <Link className={linkCx} to='/systems/' onClick={closeMobileNav}>Overview</Link>
                    <Link className={linkCx} to='/systems/market_platform/' onClick={closeMobileNav}>Market Platform</Link>
                    <Link className={linkCx} to='/systems/payment_platform/' onClick={closeMobileNav}>Payment Platform</Link>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      </div>
    </nav>
  )
}

Nav.displayName = 'components/Nav'
export default NavContainer(Nav)



// WEBPACK FOOTER //
// ./src/components/Nav.jsx